import { TFunction } from "next-i18next";
import * as Yup from "yup";

import { FIELD_NAMES } from "./constants";

export const getValidationSchema = (t: TFunction) =>
  Yup.object().shape({
    [FIELD_NAMES.FULL_NAME]: Yup.string()
      .trim()
      .max(200, t("registration-validation_messages-full_name_exceeds_maximum_length"))
      .required(t("registration-validation_messages-full_name_is_required")),
    [FIELD_NAMES.EMAIL]: Yup.string()
      .trim()
      .max(100, t("registration-validation_messages-email_exceeds_maximum_length"))
      .required(t("registration-validation_messages-email_is_required")),
    [FIELD_NAMES.MOBILE_NUMBER]: Yup.string()
      .max(30, t("registration-validation_messages-mobile_number_exceeds_maximum_length"))
      .required(t("registration-validation_messages-mobile_number_is_required")),
    [FIELD_NAMES.PASSWORD]: Yup.string()
      .max(128, t("registration-validation_messages-password_exceeds_maximum_length"))
      .required(t("registration-validation_messages-password_is_required")),
    [FIELD_NAMES.PASSWORD_REPEAT]: Yup.string()
      .max(128, t("registration-validation_messages-password_exceeds_maximum_length"))
      .oneOf([Yup.ref(FIELD_NAMES.PASSWORD), undefined], t("registration-validation_messages-passwords_must_match"))
      .required(t("registration-validation_messages-password_is_required")),
    [FIELD_NAMES.AGREEMENT]: Yup.bool()
      .oneOf([true], t("registration-validation_messages-agreement_is_required"))
      .required(t("registration-validation_messages-agreement_is_required")),
  });
